// store.js
import { writable } from "svelte/store";
export const initSettings = {
    isQuoteOpen: null,
};
export const settingsStore = writable(initSettings);
